/**
 * Represents the type of the INAD authentication parameter type
 */
const InadAuthParamType = {
  Header: 0,
  Body: 1,
};

export default InadAuthParamType;